<template>
  <a-modal
    :centered="true"
    :confirmLoading="confirmLoading"
    :destroy-on-close="true"
    :maskClosable="false"
    :visible="visible"
    :width="1300"
    @cancel="handleCancel"
    class="class-book-modal"
    footer=""
  >
    <a-icon class="close-icon" slot="closeIcon"/>
    <div ref="modalSelectRoot"></div>
    <a-spin :spinning="confirmLoading" class="login-parent">
      <div class="title">
        <div class="title-name">{{record.className}}通讯录</div>
      </div>
      <export-modal :queryParams="queryParam" :exportAction="exportAction"/>
      <s-table
        style="margin-top: 0.15rem"
        :columns="columns"
        :data="loadData"
        class="scroll-table-wrap"
        ref="table"
        rowKey="id"
        size="default"
      >
      </s-table>
    </a-spin>
  </a-modal>
</template>
<script>
  import { mapActions } from 'vuex'
  import STable from '@/components/table/'
  import classBook from '../../api/classBook'
  import { getListByCode } from '@/api/dict'
  import ExportModal from '../../components/ExportModal'

  export default {
    name: 'ClassBookModal',
    props: {},
    components: {
      STable,
      ExportModal
    },
    data() {
      return {
        dictCode: 'sex,studentPosition',
        options: {},
        visible: false,
        confirmLoading: false,
        exportAction: process.env.VUE_APP_BASE_URL + classBook.Export,
        queryParam: {},
        record: {},
        columns: [
          {
            title: '学员姓名',
            dataIndex: 'name',
          },
          {
            title: '性别',
            dataIndex: 'sex',
            ellipsis: true,
            customRender: text => {
              const target = this.options.sex && this.options.sex.filter(item => text === item.value)[0]
              return target && target.label
            }
          },
          {
            title: '工作单位',
            dataIndex: 'department',
            ellipsis: true
          },
          {
            title: '手机号码',
            dataIndex: 'telephone',
            ellipsis: true
          },
          {
            title: '班级职务',
            dataIndex: 'position',
            ellipsis: true,
            customRender: text => {
              const target = this.options.studentPosition && this.options.studentPosition.filter(item => text === item.value)[0]
              return target && target.label
            }
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          const order = parameter.sortOrder !== undefined ? parameter.sortOrder.substring(0, parameter.sortOrder.length - 3) : ''
          const page = {
            pageNo: parameter.pageNo,
            pageSize: parameter.pageSize,
            sortField: parameter.sortField,
            draw: order
          }
          return classBook.memberList(Object.assign(this.queryParam, page))
        }
      }
    },
    beforeCreate() {
    },
    created() {
    },
    mounted() {
    },
    methods: {
      ...mapActions(['GetInfo', 'GetUserData']),
      show(record) {
        this.visible = true
        this.record = record
        this.queryParam = {
          classId: record.classId,
          className: record.className
        }
        Promise.all([
          getListByCode({ dictCode: this.dictCode }).then(res => {
            this.options = { ...this.options, ...res.result.dictDefine }
            this.$refs.table.refresh(true)
          }),
        ])
      },
      handleCancel() {
        this.visible = false
      }
    },
    watch: {}
  }
</script>
<style lang="less">
  .class-book-modal {

    .ant-btn-primary {
      width: 0.75rem;
      height: 0.3rem;
      background-color: rgba(23, 77, 244, 1);
      border-color: rgba(23, 77, 244, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 0.135rem;
    }

    .close-icon {
      display: inline-block;
      width: 0.15rem;
      height: 0.15rem;
      background: url('../../assets/icons/ic_login_close@2x.png')  center/100% 100% no-repeat;
    }

    .ant-modal-content {
      border-radius: 0.0975rem;
    }

    .title-line {
      border-bottom: 0.01rem solid;
      border-color: #c5cad2;
      margin-top: 0.18rem;
    }

    .ant-modal-header {
      border: 0; // 去掉标题下面的线
      border-radius: 0.0975rem 0.0975rem 0 0;
    }

    .ant-form label, .ant-form-item-children {
      font-size: 0.12rem;
    }

    .login-parent {
      padding: 0.15rem 0.375rem 0.06rem 0.24rem;

      .title {
        margin-bottom: 0.15rem;

        .title-name {
          font-weight: 600;
          color: #191d28;
          font-size: 0.2rem;
          line-height: 0.24rem;
        }
      }

      .ant-input {
        height: 0.435rem;
        border-radius: 0.0375rem;
        font-size: 0.135rem;
      }

      .footer-btn {
        margin-top: 0.3rem;
        text-align: center;

        .reset-btn {
          width: 0.75rem;
          height: 0.3rem;
          margin-left: 0.195rem;
          background-color: rgba(0, 0, 0, 0);
          border-color: rgba(23, 77, 244, 1);
          color: rgba(23, 77, 244, 1);
          font-size: 0.135rem;
        }
      }

      .ant-form-item {
        display: flex;

        .ant-form-item-label {
          min-width: 0.825rem;
        }

        .ant-form-item-control-wrapper {
          flex: 1;
        }
      }
    }


  }
</style>
